import { render } from "./ModalRunAnalysis.vue?vue&type=template&id=3a0a6087&ts=true"
import script from "./ModalRunAnalysis.vue?vue&type=script&lang=ts"
export * from "./ModalRunAnalysis.vue?vue&type=script&lang=ts"

import "./ModalRunAnalysis.vue?vue&type=style&index=0&id=3a0a6087&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__